import { defineAsyncComponent } from "vue"

import YoutubePlayer from "./_YoutubePlayer"

export default defineAsyncComponent(async () => {
    await new Promise(resolve => {
        window.onYouTubeIframeAPIReady = resolve
        const tag = document.createElement("script")
        tag.src = "https://www.youtube.com/iframe_api"
        document.body.appendChild(tag)
    })
    return YoutubePlayer
})
